module.exports = "https://img.zhijierongxing.com/saas/img/mark_dele.efe5fa07.png";